(function() {
    'use strict';
    angular
        .module('app.filter')
        .filter('highlight', highlight);

    function highlight($sce) {
        return function(text, phrase) {

            if (phrase) {
                if (text) {
                    text = text.replace(new RegExp('(' + phrase + ')', 'gi'),
                        '<span class="font-red">$1</span>');
                }
            }

            return $sce.trustAsHtml(text);
        };
    }
})();